import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  card: {
    boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
    borderRadius: 8,
  },
  title: {
    fontWeight: 600,
    color: theme.palette.grey[800],
    marginBottom: theme.spacing(3),
  },
  section: {
    marginBottom: theme.spacing(3),
  },
  sectionLabel: {
    fontWeight: 600,
    marginBottom: theme.spacing(1.5),
  },
  radioLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  buttonWhatsApp: {
    backgroundColor: '#25D366',
    color: 'white',
    '&:hover': {
      backgroundColor: '#1DA851',
    },
  },
  buttonPrimary: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  buttonSecondary: {
    backgroundColor: theme.palette.grey[600],
    color: 'white',
    '&:hover': {
      backgroundColor: theme.palette.grey[700],
    },
  },
  buttonPurple: {
    backgroundColor: '#9c27b0',
    color: 'white',
    '&:hover': {
      backgroundColor: '#7b1fa2',
    },
  },
}));
